import React from "react";
import PropTypes from "prop-types";
import { validator } from "LIB/validate-this";
import { Col } from "react-bootstrap";
import { connect } from "react-redux";
import { Field, Fields } from "redux-form";
import { Map } from "immutable";
import * as actions from "MODULES/RepairOrders/actions";
import {
  form,
  Form as AppForm,
  FormInput
} from "MODULES/shared/components/Forms";
import {
  QUANTITY,
  RETURN_TO,
  RETURN_TO_LOCATION_ID,
  RETURN_TO_TYPE,
  SHIP_TO
} from "APP_ROOT/constants";
import { PART_COST } from "MODULES/SalesOrders/constants";
import { COMPANY, REPAIR_STATION } from "MODULES/companies/constants";
import { DO_NOT_SHIP, DROPSHIP } from "MODULES/PurchaseOrders/constants";
import ShippingFields from "MODULES/Orders/shared/ShippingFields";
import {
  InsuranceFields,
  InsuranceTypeField
} from "../Detail/LineItems/FormSections/ShippingSection/InsuranceFields";
import FormRow from "../../../shared/components/Forms/FormRow";
import { validReturnToForWarranty } from "../ConvertToRo/validate";

const formName = "editROShipping";

export function Form(props) {
  const { record, shippingType, addresses } = props;
  const shipToCompany = record.get(`${shippingType}_company`) || Map();
  const types =
    shippingType === "ship_to"
      ? [REPAIR_STATION, COMPANY, DROPSHIP]
      : [COMPANY, DROPSHIP, DO_NOT_SHIP];
  const fob = shippingType === "return_to" ? "return_to_fob" : "ship_to_fob";
  return (
    <AppForm {...props}>
      <AppForm.Body>
        <div className="row row-col-gutters-half">
          <div className="col-md-6">
            <div className="form-group">
              <Field name={fob} component={FormInput} label="FOB" required />
            </div>
          </div>
        </div>
        <ShippingFields
          shipToCompany={shipToCompany.toJS()}
          repairStationOptions={addresses}
          formName={formName}
          shippingFields={[
            `${shippingType}_type`,
            `${shippingType}_company_id`,
            `${shippingType}_company_address_id`
          ]}
          shippingTypes={types}
          shippingMethod={`${shippingType}_shipping_method`}
          shippingAddressField={`${shippingType}_shipping_address`}
          required={shippingType === SHIP_TO}
          hasLocations={shippingType !== SHIP_TO}
          locationFieldName={RETURN_TO_LOCATION_ID}
        />
        {shippingType === SHIP_TO && (
          <div key="insurance-condition-section">
            <FormRow>
              <Col md={12}>
                <Fields
                  names={[
                    "amount_insured",
                    "percent_insured",
                    "insurance_type"
                  ]}
                  component={InsuranceTypeField}
                />
              </Col>
            </FormRow>
            <FormRow>
              <Fields
                names={[
                  "amount_insured",
                  "percent_insured",
                  "insurance_type",
                  PART_COST,
                  QUANTITY
                ]}
                component={InsuranceFields}
              />
            </FormRow>
          </div>
        )}
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  record: PropTypes.shape({
    ship_to_company: PropTypes.instanceOf(Object)
  }),
  shippingType: PropTypes.string.isRequired,
  addresses: PropTypes.arrayOf(PropTypes.shape({}))
};

export default connect(undefined, { onSubmit: actions.update })(
  form({
    form: formName,
    validate: (values, props) =>
      validator(values, f => {
        if (props.shippingType === RETURN_TO) {
          f
            .validate(RETURN_TO_TYPE)
            .satisfies(val =>
              validReturnToForWarranty(val, props.record.toJS())
            );
        }
      })
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Edit/ShippingForm.jsx